var exports = {
  "kL": "xfd349460--7c91bf--container",
  "Ki": "xfd349460--7c91bf--video",
  "W_": "xfd349460--7c91bf--poster",
  "W5": "xfd349460--7c91bf--poster--hidden",
};

module.exports = exports;
